import { render, staticRenderFns } from "./CustomOverlaysFields.vue?vue&type=template&id=d66540d0&scoped=true&"
import script from "./CustomOverlaysFields.vue?vue&type=script&lang=js&"
export * from "./CustomOverlaysFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomOverlaysFields.vue?vue&type=style&index=0&id=d66540d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66540d0",
  null
  
)

export default component.exports